import { FooterPortal, NavbarPortal } from "components";
import loginImage from "../../assets/images/portal/login.webp";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { PulseLoader } from "react-spinners";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { API_URL_forgotPassword, API_URL_login } from "constants/api";
// import { loginUser } from "redux/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { isAuth } from "actions";
import { loginUser } from "actions/auth";

const ForgotPassword = () => {
  const { loginUserResult, loginUserLoading } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Email harus diisi"),
    }),
    onSubmit: (values) => {
      axios({
        method: "POST",
        data: { email: values.email },
        url: API_URL_forgotPassword,
      })
        .then((response) => {
          toast.success(response.data.message, {
            position: "top-center",
            autoClose: true,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          formik.resetForm();
        })
        .catch((error) => {
          console.log(error);
          toast.warn(error.response.data.message, {
            position: "top-center",
            autoClose: true,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
    },
  });

  const [visiblePassword, setVisiblePassword] = useState(false);

  useEffect(() => {
    if (loginUserResult || isAuth()) {
      window.location.href = "/";
    }
  }, [loginUserResult]);

  return (
    <>
      <div className="flex flex-col min-h-screen overflow-y-auto text-gray-700">
        <main className="flex flex-grow">
          <div className="w-full">
            <NavbarPortal current={"Beranda"} isGradient={true} />

            <div className="relative flex flex-row w-full justify-between">
              <div className="absolute md:static z-0 w-full md:w-1/2 h-full md:block">
                <img
                  src={loginImage}
                  className="h-[36em] gambar-login w-full"
                />
              </div>
              <div className="absolute md:static z-10 w-full md:w-1/2 bg-transparent h-fit ">
                <div className="px-5 py-5 lg:py-8 padding-topbottom lg:px-14">
                  <div className="border-2 shadow-2xl rounded-lg px-5 lg:py-8 py-5 lg:px-14 bg-white mt-10 md:mt-0 md:h-[32em]">
                    <p className="text-2xl md:text-5xl font-bold mb-4">
                      Forgot Password
                    </p>
                    <form onSubmit={formik.handleSubmit}>
                      <div className="relative mb-4">
                        <label className="font-bold">Email</label>
                        <input
                          id="email"
                          type="text"
                          name="email"
                          placeholder="Masukkan Email"
                          onChange={formik.handleChange}
                          value={formik.values.email}
                          className="w-full px-1 py-2 border-2 mt-1 border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div className="text-red-500">
                            {formik.errors.email}
                          </div>
                        )}
                      </div>

                      <button
                        type="submit"
                        disabled={loginUserLoading}
                        className="bg-gradient-to-b from-sky-600 to-sky-900 text-white w-full py-2 hover:bg-gradient-to-br text-xl"
                      >
                        {loginUserLoading ? (
                          <PulseLoader color="#fff" size={11} />
                        ) : (
                          "Send"
                        )}
                      </button>

                      <div className="text-left mt-4 text-blue-500 hover:text-blue-700">
                        <Link to={`/auth-apjii/login`}>I know my password</Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <FooterPortal />
      </div>
    </>
  );
};

export default ForgotPassword;
